import { Button as MaterialButton, withStyles, styled } from '@material-ui/core';

export const StyledButton = withStyles({
  root: {
    overflow: 'hidden',
  },
  label: {
    textTransform: 'initial',
  },
})(MaterialButton);

export const LoaderWrapper = styled('div')({
  alignItems: 'center',
  background: 'rgba(255,255,255, 0.5)',
  bottom: 0,
  display: 'flex',
  justifyContent: 'center',
  left: 0,
  position: 'absolute',
  right: 0,
  top: 0,
});
